import React from "react";

function ContactPage() {
  return <div>contactpage</div>;
}

export default ContactPage;
